export const caseHeadingColors = [
    {'name':'2C2C2C'},
    {'name':'707070'},
    {'name':'3C6748'},
    {'name':'107896'},
    {'name':'AD2A1A'},
    {'name':'C01F2D'}
]